"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const INIT_STATE = {
    selectedDecoder: {},
    decoderList: []
};
const decoderListReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case "DECODER_LIST": {
            return Object.assign({}, state, { decoderList: action.payload });
        }
        case "SELECTED_DECODER": {
            return Object.assign({}, state, { selectedDecoder: action.payload });
        }
        default:
            return state;
    }
};
exports.default = decoderListReducer;
//# sourceMappingURL=service.js.map